/**
 * Which published version an answer belongs to, free of the DOM so it can be tested.
 *
 * The server grades an answer against the version named on it (src/curriculum/answers.ts). Before,
 * it graded against whatever was live when the answer ARRIVED — so an answer to a page revised in the
 * meantime was dropped, or graded against a different question that kept the same block id.
 *
 * The version is stamped when the answer is RECORDED, not when the batch is sent: a batch waits up to
 * 600ms, and a page that patched itself to the new version in that window must not relabel an answer
 * given to the old one.
 */

let rendered: number | null = null;

/** The version the page is showing now. 0 or null while it is still being written. */
export function setRenderedVersion(version: number | null | undefined): void {
  rendered = typeof version === "number" && Number.isInteger(version) && version > 0 ? version : null;
}

export function renderedVersion(): number | null {
  return rendered;
}

/** The payload to send: an answer gains the rendered version; anything else is unchanged. */
export function stampVersion(
  kind: string,
  payload: Record<string, unknown>,
  version: number | null = rendered,
): Record<string, unknown> {
  if (kind !== "answer" || version === null) return payload;
  return { ...payload, version };
}
